__webpack_require__.p = "/public/dest/cdn";